export default __webpack_public_path__ + "static/media/red-lighten-historical.e65dd2b4.svg";